// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-928289ea] .avue-tree__filter{position:fixed;width:250px;top:115px;padding-left:10px}", ""]);
// Exports
module.exports = exports;
